import Types from '../../types';
import * as KlueTypes from '../../klue_types';

export function compareTimeseries() {
  return Types.arrayOf(KlueTypes.Timeseries).create([...arguments]);
}
